import {Link} from "react-router-dom";
import {inject, observer} from "mobx-react";
import cx from "classnames";

import {
    betOddsFormat,
    formatDate,
    formatNumber,
    isCombinedMatch,
    trans
} from "../../../common/utils";


const BetListMatch = ({match, store}) => {
    return <div
        className={cx("bets-list__group-item", match.status)}
        key={match.id + match.odds + match.oddsType}
           >
        {(match && isCombinedMatch(match.id)) ?
            <>
                <p className="bets-list__match-row">
                        <span className="bets-list__match-time">
                            <span>
                                {formatDate(match.date, "DD.MM.YYYY HH:mm")}
                            </span>
                            {match.isLive &&
                                <i title="Live Match"
                                   className="doruk-live-match-01 coupons__live-indicator"
                                />
                            }
                        </span>
                    {match.status &&
                        <span className="bets-list__status">
                                {trans(match.status[0].toUpperCase() + match.status.slice(1))}
                            </span>
                    }
                </p>
                <p className="bets-list__match-row">
                    {match.url ?
                        <Link
                            className="bets-list__match-name"
                            to={match.url}
                        >
                            {match.name}
                        </Link>
                        :
                        <p className="bets-list__match-name">{match.name}</p>
                    }
                    {match.currentScore || match.currentStatus ?
                        <p className="bets-list__match-score">
                            <span>{match.currentScore || null}</span>
                            <span> {match.currentStatus || null}</span>
                        </p>
                        : null
                    }
                    <span>{formatNumber(match.odds, 2, store.user.language)}</span>
                </p>
            </>
            :
            <>
                <p className="bets-list__group-item-info">
                        <span>
                            {formatDate(match.date, "DD.MM.YYYY, HH:mm", store.user.language)}
                            {match.isLive &&
                                <i title="Live Match"
                                   className="doruk-live-match-01 coupons__live-indicator"
                                />
                            }
                        </span>
                    <span>
                            <span className="bets-list__group-item-match-key">{match.key}</span>
                        {match.status &&
                            <span className="bets-list__group-item-status">
                                    {trans(match.status[0].toUpperCase() + match.status.slice(1))}
                                </span>
                        }

                        </span>

                </p>
                <p className="bets-list__info-odd-type">
                    <span>{`${match.oddsTypeSelection} (${match.oddsType})`}</span>
                    <span>
                            {betOddsFormat(match.odds, store.user.language)}
                        </span>
                </p>
                {match.url ?
                    <Link
                        className="bets-list__match-name"
                        to={match.url}
                    >
                        {match.name}
                    </Link>
                    :
                    <p className="bets-list__match-name">{match.name}</p>
                }
                {match.currentScore || match.currentStatus ?
                    <p className={cx(
                        "bets-list__match-score",
                        match.className
                    )}
                    >
                        <span>{match.currentScore || null}</span>
                        <span> {match.currentStatus || null}</span>
                    </p>
                    : null
                }
            </>
        }
    </div>
};

export default inject('store')(observer(BetListMatch));